import { FC } from 'react';
import { Step } from './types';

type NavigationProps = {
    steps: Step[];
    currentStepIndex: number;
};

const Navigation: FC<NavigationProps> = ({ steps, currentStepIndex }: NavigationProps) => {
    return (
        <div className={`grid grid-cols-${steps.length > 12 ? 12 : steps.length} gap-4 m-auto`}>
            {steps.map((step, index) => (
                <div
                    key={index}
                    className={`border-t-4 pt-4 ${index <= currentStepIndex ? '_border-purple-500 theme-step-border' : 'border-gray-200'}`}
                >
                    <p
                        className={`uppercase font-bold ${index <= currentStepIndex ? '_text-purple-500 theme-step-title' : 'text-gray-400'}`}
                    >
                        {step.title}
                    </p>
                    {step.description && (
                        <p className="font-semibold">{step.description}</p>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Navigation;